import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';




@Injectable({ providedIn: 'root' })
export class TutorialServcie {

    private _apiLink = environment.apiLink
    

    constructor(private _httpClient: HttpClient) { }

    ask(modal) {
        return this._httpClient.post(`${this._apiLink}ai-chat/tutorial`, modal)
    }

}
